export const DISABLE_USER_FAILURE = 'DISABLE_USER_FAILURE';

export const disableUserFailure = error => ({
    type: DISABLE_USER_FAILURE,
    payload: error,
    error: true,
});
